module.exports = __webpack_public_path__ + "media/solutions/solution-dermoscopy-e9d288d5.png";